import { PromptFormData } from "../types";

export const TEMPLATES: Record<string, PromptFormData> = {
  SUMMARIZER: {
    title: "Content Summarizer",
    promptText: `You are an expert summarizer. Create a summary of the {{text}} with the following characteristics:
- Length: {{length}} (short, medium, or long)
- Focus on {{focus}} aspects of the content
- Include {{count}} key points
- Write at a {{level}} comprehension level`,
    inputs: [
      {
        name: "text",
        description: "The text to be summarized",
        type: "textarea",
        required: true,
        renderPreferences: {
          renderType: "textarea",
          allowedSources: ["direct", "document", "url"],
        },
      },
      {
        name: "length",
        description: "How long should the summary be?",
        type: "select",
        required: true,
        renderPreferences: {
          renderType: "select",
          allowedSources: ["direct"],
          options: [
            { label: "Short", value: "short" },
            { label: "Medium", value: "medium" },
            { label: "Long", value: "long" },
          ],
        },
      },
      {
        name: "focus",
        description: "What should the summary focus on?",
        type: "text",
        required: true,
        renderPreferences: {
          renderType: "text",
          allowedSources: ["direct"],
        },
      },
      {
        name: "count",
        description: "How many key points to include?",
        type: "number",
        required: true,
        renderPreferences: {
          renderType: "number",
          allowedSources: ["direct"],
        },
      },
      {
        name: "level",
        description: "What reading level should it be written for?",
        type: "select",
        required: true,
        renderPreferences: {
          renderType: "select",
          allowedSources: ["direct"],
          options: [
            { label: "Elementary", value: "elementary" },
            { label: "High School", value: "high school" },
            { label: "College", value: "college" },
          ],
        },
      },
    ],
    outputs: [
      {
        name: "summary",
        description: "The generated summary",
        type: "string",
      },
      {
        name: "key_points",
        description: "List of key points extracted from the text",
        type: "array",
      },
    ],
  },
  QUIZ: {
    title: "Quiz Generator",
    promptText: `Create {{count}} {{question_type}} questions from the {{text}} at a {{difficulty_level}} difficulty level.

Each question should:
- Be clearly worded and easy to understand
- Focus on important concepts
- Have a well-explained answer`,
    inputs: [
      {
        name: "text",
        description: "The content to create questions from",
        type: "textarea",
        required: true,
        renderPreferences: {
          renderType: "textarea",
          allowedSources: ["direct", "document", "url"],
        },
      },
      {
        name: "count",
        description: "How many questions?",
        type: "number",
        required: true,
        renderPreferences: {
          renderType: "number",
          allowedSources: ["direct"],
        },
      },
      {
        name: "question_type",
        description: "What type of questions?",
        type: "select",
        required: true,
        renderPreferences: {
          renderType: "select",
          allowedSources: ["direct"],
          options: [
            { label: "Multiple Choice", value: "multiple choice" },
            { label: "Short Answer", value: "short answer" },
            { label: "True/False", value: "true/false" },
          ],
        },
      },
      {
        name: "difficulty_level",
        description: "What difficulty level?",
        type: "select",
        required: true,
        renderPreferences: {
          renderType: "select",
          allowedSources: ["direct"],
          options: [
            { label: "Beginner", value: "beginner" },
            { label: "Intermediate", value: "intermediate" },
            { label: "Advanced", value: "advanced" },
          ],
        },
      },
    ],
    outputs: [
      {
        name: "question",
        description: "The question text",
        type: "string",
      },
      {
        name: "answer",
        description: "Correct answer and explanation",
        type: "string",
      },
    ],
  },
};
